export const API_SEARCH_COMPANY = 'API_SEARCH_COMPANY'
export const API_SEARCH_COMPANY_SUCCESS = 'API_SEARCH_COMPANY_SUCCESS'
export const API_SEARCH_COMPANY_FAIL = 'API_SEARCH_COMPANY_FAIL'

export const API_ADMIN_GET_ALL_COMPANY = 'API_ADMIN_GET_ALL_COMPANY'
export const API_ADMIN_GET_ALL_COMPANY_SUCCESS = 'API_ADMIN_GET_ALL_COMPANY_SUCCESS'
export const API_ADMIN_GET_ALL_COMPANY_FAIL = 'API_ADMIN_GET_ALL_COMPANY_FAIL'

export const API_ADMIN_GET_COMPANY = 'API_ADMIN_GET_COMPANY'
export const API_ADMIN_GET_COMPANY_SUCCESS = 'API_ADMIN_GET_COMPANY_SUCCESS'
export const API_ADMIN_GET_COMPANY_FAIL = 'API_ADMIN_GET_COMPANY_FAIL'

export const ADMIN_RESET_FOCUS_COMPANY = 'ADMIN_RESET_FOCUS_COMPANY'

